import { ThongTinBienLai } from "./../../../pages/he-thong/cau-hinh/CauHinhHeThongPage";
import { v4 as uuidv4 } from "uuid";
import { parseDatetimeLocalToUTC } from "../../../helpers/commonHelper";
import {
  IThuPhiTab,
  IThuPhiThongTinBienLai,
} from "../../../model/request/thu-phi/IThuPhiTab";
import { IMucThuKhacSinhVienViewModel } from "../../../model/respone/chung-tu/IMucThuKhacSinhVienViewModel";
import { IThuPhiActionTypes } from "../../action-types/thu-phi/IThuPhiActionTypes";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IThuPhiReducer } from "../../reducer-model/thu-phi/IThuPhiReducer";
import { IQRCodeResponse } from "../../../model/respone/ngan-hang/IQRCodeResponse";

const iniTab: IThuPhiTab = {
  id: uuidv4(),
  title: "Untitled",
  mucThuKhacs: [],
  mucThuKhacSelectedIds: [],
  step: 0,
  hinhThucNops: [],
  status: eReducerStatusBase.is_not_initialization,
  hocKy: 0,
  namHoc: "",
  qrCode: {
    bank_code_vnpay: "",
    id_encode: 0,
    qrcode: "",
    show_modal: false,
  } as IQRCodeResponse,
  thongTinBienLai: {
    bienLaiId: 0,
    bienLaiPhieuThu: "",
    bienLaiTempPhieuThu: "",
    loaiBienLai: "thu",
    ngayThu: undefined,
    chiTuBienLaiId: 0,
  } as IThuPhiThongTinBienLai,
};
const iniState: IThuPhiReducer = {
  selectedId: iniTab.id,
  tabs: [iniTab],
};
export const thuPhiReducer = (
  state: IThuPhiReducer = iniState,
  action: IThuPhiActionTypes,
): IThuPhiReducer => {
  switch (action.type) {
    case "THU_PHI_ADD_NEW_TAB":
      let exist = state.tabs.find(
        (g) =>
          g.sinhVien?.id_sv === action.payload?.id_sv &&
          g.thongTinBienLai.bienLaiId <= 0,
      );
      const id = exist?.id ?? uuidv4();
      return {
        ...state,
        selectedId: id,
        tabs: exist
          ? [...state.tabs]
          : [
              {
                ...iniTab,
                title: action.payload?.ho_ten ?? "Untitled",
                id: id,
                sinhVien: action.payload,
              },
              ...state.tabs,
            ],
      };
    case "THU_PHI_RENEW_TAB_BY_ID":
      var id_tab_new = uuidv4();
      return {
        ...state,
        selectedId: id_tab_new,
        tabs: [
          ...state.tabs.filter((x) => x.id !== action.payload.id),
          {
            ...iniTab,
            title: action.payload.data.ho_ten ?? "Untitled",
            id: id_tab_new,
            sinhVien: action.payload.data,
          },
        ],
      };
    case "THU_PHI_REMOVE_TAB":
      return {
        ...state,
        tabs: state.tabs.filter((t) => t.id !== action.payload),
      };
    case "THU_PHI_UPDATE_TAB_DATA":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.id === action.payload.id) {
            return action.payload;
          }
          return t;
        }),
      };
    case "THU_PHI_CHANGEG_SELECTED_TAB":
      return {
        ...state,
        selectedId: action.payload,
      };
    case "THU_PHI_LOAD_MUC_THU_KHAC_START":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.id_sv) {
            return {
              ...t,
              status: eReducerStatusBase.is_loading,
              step: t.thongTinBienLai.bienLaiId > 0 ? t.step : 0,
              hocKy: action.payload.hoc_ky,
              namHoc: action.payload.nam_hoc,
            };
          }
          return t;
        }),
      };
    case "THU_PHI_LOAD_MUC_THU_KHAC_SUCCESS":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            return {
              ...t,
              status: eReducerStatusBase.is_completed,
              mucThuKhacs: action.payload.data,
              hinhThucNops: [],
              mucThuKhacSelectedIds: [],
              // step: 0,
            };
          }
          return t;
        }),
      };
    case "THU_PHI_LOAD_MUC_THU_KHAC_ERROR":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            return {
              ...t,
              status: eReducerStatusBase.is_completed,
              mucThuKhacs: [],
            };
          }
          return t;
        }),
      };
    case "THU_PHI_CHANGE_MUC_THU_KHAC_SELECTED_IDs":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            let muc_thu_selected_id_news = action.payload.data.filter(
              (item) => !t.mucThuKhacSelectedIds.includes(item),
            );
            return {
              ...t,
              hinhThucNops: [],
              mucThuKhacSelectedIds: action.payload.data,
              mucThuKhacs: t.mucThuKhacs.map((g) => {
                if (action.payload.data.includes(g.id)) {
                  if (muc_thu_selected_id_news?.includes(g.id)) {
                    return {
                      ...g,
                      so_tien_thuc_nop: Math.abs(
                        g.lop_tin_chis && g.lop_tin_chis.length > 0
                          ? g.lop_tin_chis.reduce(
                              (a, b) => a + (b.so_tien_con_lai ?? 0),
                              0,
                            )
                          : g.so_tien_con_lai < 0
                            ? 0
                            : g.so_tien_con_lai,
                      ),
                      lop_tin_chis: g?.lop_tin_chis
                        ?.filter((ltc) =>
                          t.thongTinBienLai.loaiBienLai === "thu"
                            ? (ltc.so_tien_con_lai ?? 0) > 0
                            : // Phiếu CHI TỪ PHIẾU: giữ học phần để chi được TỪNG MÔN (máy chủ đã
                              // cắt còn đúng môn có trên phiếu nguồn). Trước đây trả false = XOÁ
                              // SẠCH học phần ngay khi tích khoản ⇒ bảng chi tiết không hiện,
                              // phiếu chi chỉ ghi được một dòng gộp cả đợt.
                              // Chi tiền THỪA (không chọn phiếu nguồn) giữ nguyên hành vi cũ.
                              (t.thongTinBienLai.chiTuBienLaiId ?? 0) > 0 ||
                              (t.thongTinBienLai.chiTuBienLaiIds?.length ?? 0) >
                                0,
                        )
                        .map((ltc) => {
                          return {
                            ...ltc,
                            is_choose: true,
                            so_tien_thuc_nop: Math.abs(
                              ltc.so_tien_con_lai ?? 0,
                            ),
                          };
                        }),
                    };
                  }
                  return g;
                }
                return {
                  ...g,
                  so_tien_thuc_nop: 0,
                  lop_tin_chis: g?.lop_tin_chis?.map((ltc) => {
                    return {
                      ...ltc,
                      is_choose: false,
                      so_tien_thuc_nop: 0,
                    };
                  }),
                };
              }),
            };
          }
          return t;
        }),
      };
    case "THU_PHI_CHANGE_STEP":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            return {
              ...t,
              step: action.payload.data,
            };
          }
          return t;
        }),
      };
    case "THU_PHI_CHANGE_HINHTHUCNOP":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            return {
              ...t,
              hinhThucNops: action.payload.data,
            };
          }
          return t;
        }),
      };
    case "THU_PHI_CREATE_BIENLAITHU_START":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.id_sv) {
            return {
              ...t,
              status: eReducerStatusBase.is_saving,
            };
          }
          return t;
        }),
      };
    case "THU_PHI_CREATE_BIENLAITHU_SUCCESS":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            return {
              ...t,
              status: eReducerStatusBase.is_need_reload,
              thongTinBienLai: {
                ...t.thongTinBienLai,
                bienLaiId: action.payload.data,
              },
              step: 2,
            };
          }
          return t;
        }),
      };
    case "THU_PHI_CREATE_BIENLAITHU_ERROR":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            return {
              ...t,
              status: eReducerStatusBase.is_completed,
              bienLaiId: 0,
            };
          }
          return t;
        }),
      };
    case "THU_PHI_LOAD_EDIT_BIENLAI_SUCCESS": {
      const detail = action.payload.data;
      const chiTiets = detail?.bienLaiThuChiTiets ?? [];
      // chi tiết tín chỉ mang id_mon_tc; chi tiết thường mang id_thu_chi (id_mon_tc = 0).
      const soTienByMonTc: { [key: number]: number } = {};
      chiTiets.forEach((c: any) => {
        if (c.id_mon_tc && c.id_mon_tc !== 0) {
          soTienByMonTc[c.id_mon_tc] =
            (soTienByMonTc[c.id_mon_tc] ?? 0) + c.so_tien;
        }
      });
      // Ghi chú theo TỪNG khoản: nạp lại để sửa được (trước đây chỉ nạp số tiền → mở sửa
      // là ô ghi chú trống, lưu lại mất ghi chú cũ).
      // ⚠ BE luồng này lưu `ghi_chu = ghi_chu_dong NẾU CÓ, không thì noi_dung của khoản`
      // (BienLaiThuChiTietService.cs:63) → phải LOẠI trường hợp bằng đúng noi_dung, nếu
      // không sẽ đổ nội dung khoản vào ô ghi chú dù người dùng chưa hề nhập gì.
      const ghiChuByThuChi: { [key: number]: string } = {};
      chiTiets.forEach((c: any) => {
        const g = (c.ghi_chu ?? "").trim();
        if (g && !ghiChuByThuChi[c.id_thu_chi])
          ghiChuByThuChi[c.id_thu_chi] = c.ghi_chu;
      });
      const ghiChuNguoiDung = (ghiChu: string, noi_dung?: string) => {
        const g = ghiChu ?? "";
        return g && g !== (noi_dung ?? "") ? g : "";
      };
      /*
        Khớp mỗi DÒNG CHI TIẾT vào ĐÚNG MỘT khoản, theo thứ tự chắc chắn dần:
          id mức thu -> (loại thu chi + kỳ + năm + đợt) -> (loại + kỳ + năm) -> loại thu chi.
        ⚠ Trước đây gom theo mỗi LOẠI THU CHI: sinh viên có nhiều khoản cùng loại ở các đợt/kỳ khác
        nhau (học phí gia hạn đợt 1..8) thì dòng nào cũng bị điền tiền và tự tích chọn -> lưu lại là
        nhân tiền lên nhiều lần. Khoản cũ đã bị gom lại nên id mức thu trên phiếu có thể không còn,
        vì vậy vẫn phải giữ các nấc khớp sau.
      */
      const khopKhoan = (ds: any[], c: any) =>
        (c.id_muc_thu_khac > 0
          ? ds.find((g) => g.id > 0 && g.id === c.id_muc_thu_khac)
          : undefined) ??
        ds.find(
          (g) =>
            g.id_thu_chi === c.id_thu_chi &&
            g.hoc_ky === c.hoc_ky &&
            (g.nam_hoc ?? "") === (c.nam_hoc ?? "") &&
            (g.dot ?? 0) === (c.dot ?? 0),
        ) ??
        ds.find(
          (g) =>
            g.id_thu_chi === c.id_thu_chi &&
            g.hoc_ky === c.hoc_ky &&
            (g.nam_hoc ?? "") === (c.nam_hoc ?? ""),
        ) ??
        ds.find((g) => g.id_thu_chi === c.id_thu_chi);
      // Phiếu CHI: khoản nạp theo biên lai NGUỒN đang tính CẢ phần "đã chi" của chính phiếu đang sửa →
      // Còn lại bị thiếu. CỘNG LẠI phần chi của phiếu này vào Còn lại (và trừ khỏi Đã chi) để sửa lại được đủ.
      const isChi = !!detail?.thu_chi;
      const chiNguonIds: number[] = (
        detail?.chi_nguon_bien_lai_ids ?? []
      ).filter((x: number) => x > 0);
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            // Tiền + ghi chú của từng dòng chi tiết, gán về ĐÚNG khoản (xem khopKhoan ở trên).
            const soTienByKhoanId: { [key: number]: number } = {};
            const ghiChuByKhoanId: { [key: number]: string } = {};
            chiTiets
              .filter((c: any) => !(c.id_mon_tc && c.id_mon_tc !== 0))
              .forEach((c: any) => {
                const khoan = khopKhoan(t.mucThuKhacs, c);
                if (!khoan) return;
                soTienByKhoanId[khoan.id] =
                  (soTienByKhoanId[khoan.id] ?? 0) + c.so_tien;
                const g = (c.ghi_chu ?? "").trim();
                if (g && !ghiChuByKhoanId[khoan.id])
                  ghiChuByKhoanId[khoan.id] = c.ghi_chu;
              });
            const mucThuKhacs = t.mucThuKhacs.map((g) => {
              if (g.lop_tin_chis && g.lop_tin_chis.length) {
                let total = 0;
                const lop_tin_chis = g.lop_tin_chis.map((l) => {
                  if (l.id_mon_tc && soTienByMonTc[l.id_mon_tc] != null) {
                    const st = soTienByMonTc[l.id_mon_tc];
                    total += st;
                    return {
                      ...l,
                      is_choose: true,
                      so_tien_thuc_nop: st,
                      // Lop tín chỉ chỉ có so_tien_con_lai (không có so_tien_da_chi) → chỉ cộng lại Còn lại.
                      so_tien_con_lai: isChi
                        ? (l.so_tien_con_lai ?? 0) + st
                        : l.so_tien_con_lai,
                    };
                  }
                  return { ...l, is_choose: false, so_tien_thuc_nop: 0 };
                });
                return {
                  ...g,
                  lop_tin_chis,
                  so_tien_thuc_nop: total,
                  // Nhánh tín chỉ BE lưu ghi_chu = ghi_chu_dong ?? "" nên nạp thẳng được.
                  ghi_chu_dong: ghiChuByThuChi[g.id_thu_chi] ?? "",
                  so_tien_con_lai: isChi
                    ? (g.so_tien_con_lai ?? 0) + total
                    : g.so_tien_con_lai,
                };
              }
              const prefill = soTienByKhoanId[g.id] ?? 0;
              return {
                ...g,
                so_tien_thuc_nop: prefill,
                ghi_chu_dong: ghiChuNguoiDung(
                  ghiChuByKhoanId[g.id] ?? "",
                  g.noi_dung,
                ),
                so_tien_con_lai: isChi
                  ? (g.so_tien_con_lai ?? 0) + prefill
                  : g.so_tien_con_lai,
                so_tien_da_chi: isChi
                  ? Math.max(0, (g.so_tien_da_chi ?? 0) - prefill)
                  : g.so_tien_da_chi,
              };
            });
            const selectedIds = mucThuKhacs
              .filter((g) => (g.so_tien_thuc_nop ?? 0) > 0)
              .map((g) => g.id);
            return {
              ...t,
              editingBienLaiId: detail.id_bien_lai,
              // Phiếu QR/ngân hàng: khóa khoản + số tiền, chỉ mở ghi chú và thời gian nộp.
              chiSuaGhiChuNgay: detail.chi_sua_ghi_chu_ngay === true,
              editingSoPhieu: `${detail.so_phieu_header ?? ""}${detail.so_phieu ?? ""}`,
              editingSoTien: detail.so_tien,
              step: 0,
              status: eReducerStatusBase.is_completed,
              mucThuKhacs,
              mucThuKhacSelectedIds: selectedIds,
              hinhThucNops: (detail.bienLaiThuHinhThucNops ?? []).map(
                (h: any, idx: number) => ({
                  id: idx,
                  so_tien: h.so_tien,
                  acc_bienlaithu_hinhthucnoptien_id:
                    h.acc_bienlaithu_hinhthucnoptien_id,
                  acc_bienlaithu_hinhthucnoptien_name:
                    h.acc_bienlaithu_hinhthucnoptien_name ?? "",
                  ghi_chu: h.ghi_chu ?? "",
                  id_bien_lai: detail.id_bien_lai,
                }),
              ),
              thongTinBienLai: {
                ...t.thongTinBienLai,
                bienLaiId: 0,
                bienLaiTempPhieuThu: "",
                loaiBienLai: detail.thu_chi ? "chi" : "thu",
                // Phiếu chi: luôn dùng đường "gộp nhiều nguồn" (chiTuBienLaiId=0 + chiTuBienLaiIds) — kể cả 1 nguồn.
                chiTuBienLaiId: 0,
                chiTuBienLaiIds: isChi ? chiNguonIds : [],
                // ★ Ép "giờ tường vào UTC" (parseDatetimeLocalToUTC) chứ KHÔNG new Date() thô:
                // chuỗi server không có múi giờ nên new Date() hiểu là giờ địa phương, lúc lưu
                // chỉnh sửa JSON.stringify trả về UTC → ngày thu bị LÙI 7 TIẾNG mỗi lần lưu.
                ngayThu: detail.ngay_thu
                  ? parseDatetimeLocalToUTC(detail.ngay_thu)
                  : t.thongTinBienLai.ngayThu,
                idCoSo: detail.id_co_so ?? t.thongTinBienLai.idCoSo,
              },
            };
          }
          return t;
        }),
      };
    }
    case "THU_PHI_CANCEL_EDIT_BIENLAI":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.id_sv) {
            return {
              ...t,
              editingBienLaiId: 0,
              chiSuaGhiChuNgay: false,
              editingSoPhieu: undefined,
              editingSoTien: undefined,
              mucThuKhacSelectedIds: [],
              hinhThucNops: [],
              step: 0,
              status: eReducerStatusBase.is_need_reload,
              thongTinBienLai: {
                ...t.thongTinBienLai,
                bienLaiId: 0,
                bienLaiTempPhieuThu: "",
              },
            };
          }
          return t;
        }),
      };
    case "THU_PHI_UPDATE_BIENLAITHU_START":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.id_sv) {
            return { ...t, status: eReducerStatusBase.is_saving };
          }
          return t;
        }),
      };
    case "THU_PHI_UPDATE_BIENLAITHU_SUCCESS":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            return {
              ...t,
              status: eReducerStatusBase.is_need_reload,
              editingBienLaiId: 0,
              chiSuaGhiChuNgay: false,
              editingSoPhieu: undefined,
              editingSoTien: undefined,
              thongTinBienLai: {
                ...t.thongTinBienLai,
                bienLaiId: action.payload.data,
              },
              step: 2,
            };
          }
          return t;
        }),
      };
    case "THU_PHI_UPDATE_BIENLAITHU_ERROR":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            return { ...t, status: eReducerStatusBase.is_completed };
          }
          return t;
        }),
      };
    case "THU_PHI_CHANGE_MUC_THU_KHAC_SELECTED_IDs_LOP_TIN_CHI":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            return {
              ...t,
              hinhThucNops: [],
              mucThuKhacs: [
                ...t.mucThuKhacs.map((mtk: IMucThuKhacSinhVienViewModel) => {
                  if (mtk.lop_tin_chis && mtk.lop_tin_chis.length > 0) {
                    const lop_tin_chis_choose = mtk.lop_tin_chis.filter((g) =>
                      action.payload.data.includes(g.id_lop_tc),
                    );
                    const { so_tien, so_tien_mien_giam, so_tien_da_nop } =
                      lop_tin_chis_choose.reduce(
                        (acc, item) => {
                          acc.so_tien += item.hoc_phi_theo_hoc_phan;
                          acc.so_tien_mien_giam += item.so_tien_mg_neu_co || 0;
                          if (item.is_da_nop_du)
                            acc.so_tien_da_nop += item.hoc_phi_theo_hoc_phan;
                          return acc;
                        },
                        { so_tien: 0, so_tien_mien_giam: 0, so_tien_da_nop: 0 },
                      );
                    // ★ Biên lai CHI: số tiền được chi của một học phần là phần TIỀN ĐÃ THU còn
                    // lại của môn đó (máy chủ trả sẵn ở so_tien_con_lai), KHÔNG phải phần còn
                    // thiếu như luồng thu. Dùng nhầm công thức thu thì môn đã nộp đủ sẽ ra 0đ,
                    // tích chọn xong vẫn không chi được đồng nào.
                    const laChi = t.thongTinBienLai?.loaiBienLai === "chi";
                    const tienChiCuaMon = (ltc: any) =>
                      Math.abs(ltc?.so_tien_con_lai ?? 0);
                    const tienThuCuaMon = (ltc: any) =>
                      Math.abs(
                        ltc.hoc_phi_theo_hoc_phan -
                          (ltc?.so_tien_mg_neu_co ?? 0) -
                          (ltc?.so_tien_da_nop ?? 0),
                      );
                    return {
                      ...mtk,
                      so_tien_thuc_nop: laChi
                        ? lop_tin_chis_choose.reduce(
                            (a, x) => a + tienChiCuaMon(x),
                            0,
                          )
                        : Math.abs(
                            so_tien - so_tien_mien_giam - so_tien_da_nop,
                          ),
                      lop_tin_chis: mtk.lop_tin_chis.map((ltc) => {
                        const daChon = action.payload.data.includes(
                          ltc.id_lop_tc,
                        );
                        return {
                          ...ltc,
                          is_choose: daChon,
                          so_tien_thuc_nop: !daChon
                            ? 0
                            : laChi
                              ? tienChiCuaMon(ltc)
                              : tienThuCuaMon(ltc),
                        };
                      }),
                    };
                  }
                  return mtk;
                }),
              ],
            };
          }
          return t;
        }),
      };
    case "THU_PHI_CHANGE_SO_TIEN_THUC_NOP":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            return {
              ...t,
              hinhThucNops: [],
              mucThuKhacSelectedIds: [
                ...t.mucThuKhacSelectedIds.filter(
                  (g) => g !== (action.payload.request?.id ?? 0),
                ),
                action.payload.data > 0 ? (action.payload.request?.id ?? 0) : 0,
              ],
              mucThuKhacs: [
                ...t.mucThuKhacs.map((mtk: IMucThuKhacSinhVienViewModel) => {
                  if (mtk.id === action.payload.request.id) {
                    if (action.payload.request.id_lop_tc) {
                      return {
                        ...mtk,
                        lop_tin_chis: mtk.lop_tin_chis?.map((ltc) => {
                          if (
                            ltc.id_lop_tc === action.payload.request.id_lop_tc
                          ) {
                            return {
                              ...ltc,
                              so_tien_thuc_nop: action.payload.data,
                              is_choose: action.payload.data > 0,
                            };
                          }
                          return ltc;
                        }),
                        so_tien_thuc_nop: mtk.lop_tin_chis
                          ?.filter(
                            (g) =>
                              g.id_lop_tc !== action.payload.request.id_lop_tc,
                          )
                          ?.reduce(
                            (a, b) => a + (b.so_tien_thuc_nop ?? 0),
                            action.payload.data,
                          ),
                      };
                    } else {
                      return {
                        ...mtk,
                        so_tien_thuc_nop: action.payload.data,
                      };
                    }
                  }
                  return mtk;
                }),
              ],
            };
          }
          return t;
        }),
      };
    case "THU_PHI_CHANGE_GHI_CHU_KHOAN":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            const req = action.payload.request as any;
            const targetId = req.id ?? req.id_muc_thu_goc ?? 0;
            return {
              ...t,
              mucThuKhacs: t.mucThuKhacs.map(
                (mtk: IMucThuKhacSinhVienViewModel) =>
                  mtk.id === targetId ||
                  mtk.id_muc_thu_goc === targetId ||
                  (mtk.id_muc_thu_goc == null && mtk.id === targetId)
                    ? { ...mtk, ghi_chu_dong: action.payload.data }
                    : mtk,
              ),
            };
          }
          return t;
        }),
      };
    case "THU_PHI_CHANGE_DIEU_CHINH_GIAM_DINH_MUC":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            return {
              ...t,
              hinhThucNops: [],
              mucThuKhacSelectedIds: [
                ...t.mucThuKhacSelectedIds.filter(
                  (g) => g !== (action.payload.request?.id ?? 0),
                ),
                action.payload.request?.id ?? 0,
              ],
              mucThuKhacs: [
                ...t.mucThuKhacs.map((mtk: IMucThuKhacSinhVienViewModel) => {
                  if (mtk.id === action.payload.request.id) {
                    // Chọn khoản / môn qua ô "Điều chỉnh giảm định mức" cũng phải điền sẵn
                    // "Thực chi" y như tích dòng (tiền còn chi được của khoản / môn trên phiếu
                    // nguồn) — trước đây được chọn nhưng số tiền để 0. Đã chọn rồi thì giữ số
                    // người dùng đang nhập.
                    const daChonKhoan = t.mucThuKhacSelectedIds.includes(mtk.id);
                    if (action.payload.request.id_lop_tc) {
                      const lop_tin_chis = mtk.lop_tin_chis?.map((ltc) => {
                        if (
                          ltc.id_lop_tc === action.payload.request.id_lop_tc
                        ) {
                          return {
                            ...ltc,
                            is_dieu_chinh_dinh_muc: action.payload.data,
                            is_choose: true,
                            so_tien_thuc_nop: ltc.is_choose
                              ? ltc.so_tien_thuc_nop
                              : Math.abs(ltc.so_tien_con_lai ?? 0),
                          };
                        }
                        return ltc;
                      });
                      return {
                        ...mtk,
                        is_dieu_chinh_dinh_muc: action.payload.data,
                        lop_tin_chis,
                        // Tiền của khoản = cộng các môn đang chọn (cùng cách tích môn).
                        so_tien_thuc_nop: (lop_tin_chis ?? [])
                          .filter((x) => x.is_choose)
                          .reduce((a, x) => a + (x.so_tien_thuc_nop ?? 0), 0),
                      };
                    } else {
                      return {
                        ...mtk,
                        is_dieu_chinh_dinh_muc: action.payload.data,
                        so_tien_thuc_nop: daChonKhoan
                          ? mtk.so_tien_thuc_nop
                          : Math.abs(mtk.so_tien_con_lai),
                      };
                    }
                  }
                  return mtk;
                }),
              ],
            };
          }
          return t;
        }),
      };
    case "THU_PHI_CHANGE_THONGTINBIENLAI":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            let obj = {
              ...t,
              thongTinBienLai: {
                ...t.thongTinBienLai,
                ...action.payload.data,
              },
            };
            if ("loaiBienLai" in action.payload.data) {
              obj = {
                ...obj,
                mucThuKhacs: [],
                mucThuKhacSelectedIds: [],
                hinhThucNops: [],
                step: 0,
                status: eReducerStatusBase.is_need_reload,
              };
            }
            return obj;
          }
          return t;
        }),
      };
    case "THU_PHI_LOAD_MUC_THU_KHAC_START_BY_MUCTHUID":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (
            action.payload.filter((value) =>
              t.mucThuKhacs.map((p) => p.id).includes(value),
            ).length > 0 &&
            t.thongTinBienLai.bienLaiId <= 0
          ) {
            return {
              ...t,
              status: eReducerStatusBase.is_need_reload,
              hinhThucNops: [],
              mucThuKhacs: [],
              mucThuKhacSelectedIds: [],
              step: 0,
            };
          }
          return t;
        }),
      };
    case "THU_PHI_PREVIEW_BIENLAITHU_SUCCESS":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            return {
              ...t,
              thongTinBienLai: {
                ...t.thongTinBienLai,
                bienLaiTempPhieuThu: action.payload.data,
              },
            };
          }
          return t;
        }),
      };
    case "THU_PHI_PREVIEW_BIENLAITHU_CLOSE":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            return {
              ...t,
              thongTinBienLai: {
                ...t.thongTinBienLai,
                bienLaiTempPhieuThu: "",
              },
            };
          }
          return t;
        }),
      };
    case "THU_PHI_UPDATE_QRCODE":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.id === action.payload.id) {
            return {
              ...t,
              qrCode: action.payload.data,
            };
          }
          return t;
        }),
      };
    case "THU_PHI_UPDATE_QRCODES":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.id === action.payload.id) {
            return {
              ...t,
              qrCodes: action.payload.data,
            };
          }
          return t;
        }),
      };
    case "THU_PHI_UPDATE_GENQR_LOADING":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.id === action.payload.id) {
            return {
              ...t,
              genQRLoading: action.payload.data,
            };
          }
          return t;
        }),
      };
    default:
      return state;
  }
};
